import React, { useState } from "react";
import PropTypes from "prop-types";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL;

const getVideoThumbnail = (url) => {
  let videoId = "";
  let isShorts = false;

  if (!url) return { videoId: "", thumbnail: "", lightboxUrl: "" };

  // Case 1: youtu.be short link
  if (url.includes("youtu.be/")) {
    videoId = url.split("youtu.be/")[1].split("?")[0];
  }
  // Case 2: regular YouTube link
  else if (url.includes("v=")) {
    videoId = url.split("v=")[1].split("&")[0];
  }
  // Case 3: YouTube Shorts link
  else if (url.includes("/shorts/")) {
    videoId = url.split("/shorts/")[1].split("?")[0];
    isShorts = true;
  }

  // Fallback: extract 11-char video ID
  if (!videoId && url.match(/([a-zA-Z0-9_-]{11})/)) {
    videoId = url.match(/([a-zA-Z0-9_-]{11})/)[1];
  }

  // Use different embed URLs for shorts
  const embedUrl = isShorts
    ? `https://www.youtube.com/watch?v=${videoId}&autoplay=1`
    : `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

  return {
    videoId,
    thumbnail: videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : "",
    lightboxUrl: embedUrl,
  };
};

const BlogList = ({ data, StyleVar }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { thumbnail, lightboxUrl } = data.video_url
    ? getVideoThumbnail(data.video_url)
    : {
        thumbnail: `${ASSET_BASE_URL}/storage/${data.image}`,
        lightboxUrl: "",
      };

  // --- START OF MODIFIED VIDEO SOURCE WITH RESPONSIVE CONTAINER ---
  const videoSource = data.video_url ? (
    // 1. Outer Container: Sets the max width and uses padding-top for 16:9 aspect ratio (9/16 = 0.5625)
    <div 
      style={{
        position: 'relative',
        width: '90vw', // Take up 90% of the viewport width
        paddingTop: '50.625vw', // (90vw * 0.5625) ensures a 16:9 ratio
        margin: '0 auto',
        display: 'block', 
      }}
    >
      <iframe
        // 2. Iframe: Absolutely positioned to fill the container, adding referrerPolicy
        referrerPolicy="strict-origin-when-cross-origin" // Requested attribute
        src={lightboxUrl}
        title={data.title || "Embedded Video"}
        frameBorder="0"
        // Ensure proper permissions for playback and fullscreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '85%',
          marginTop: '5%',
        }}
      />
    </div>
  ) : null;
  // --- END OF MODIFIED VIDEO SOURCE ---

  return (
    <>
      <div
        className={`rounded-xl overflow-hidden ${StyleVar}`}
        style={{ cursor: "pointer", position: "relative", aspectRatio: "16/9" }}
        onClick={() => setIsOpen(true)}
      >
        <img
          src={thumbnail}
          alt="thumbnail"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          // Added onError handling back for robustness
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/default-image.jpg"; // your fallback image
          }}
        />

        {/* Play button overlay, only show if video exists */}
        {data.video_url && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(95deg, rgb(5, 157, 255) 15%, rgb(101, 73, 213) 45%, rgb(227, 63, 161) 75%, rgb(251, 83, 67) 100%)",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FiPlay style={{ fontSize: "20px", color: "#ffffff" }} />
            </div>
          </div>
        )}
      </div>

      {data.video_url && (
        <FsLightbox toggler={isOpen} sources={[videoSource]} key={lightboxUrl} />
      )}
    </>
  );
};

BlogList.propTypes = {
  data: PropTypes.object.isRequired,
  StyleVar: PropTypes.string,
};

export default BlogList;